import { generateTestId } from "@client-shared";

export const setInvoiceTableTestId = (identifier: string): string =>
  generateTestId("InvoiceTable", identifier);

// Specific element testIds
export const setInvoiceTableContainerTestId = (): string =>
  setInvoiceTableTestId("container");

export const setInvoiceTableHeaderTestId = (
  column:
    | "invoiceId"
    | "amount"
    | "status"
    | "payDueDate"
    | "totalOrders"
    | "paymentStatus"
    | "action",
): string => setInvoiceTableTestId(`header-${column}`);

export const setInvoiceTableRowTestId = (invoiceId: string): string =>
  setInvoiceTableTestId(`row-${invoiceId}`);

export const setInvoiceTableEmptyMessageTestId = (): string =>
  setInvoiceTableTestId("empty-message");

export const setInvoiceTableStatusBadgeTestId = (invoiceId: string): string =>
  setInvoiceTableTestId(`status-badge-${invoiceId}`);
